module.exports = __webpack_public_path__ + "img/timer_blue.ebd498ff.svg";